export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_08.67554968.jpg";